<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nome</label>
                <input type="text" v-model="objEdicao.nmcliente" required maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">CPF/CNPJ</label>
                <input type="text" class="input-center" v-model="objEdicao.cpfcnpj" v-mask-cpf-cnpj maxlength="18" />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Municipio</label>
                <input type="text" v-model="objEdicao.nmmunicipio" required maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char05">
                <label class="label-caption">UF</label>
                <input type="text" class="input-center" v-model="objEdicao.uf" maxlength="2" v-uppercase />
            </div>
        </div>
        
        <div class="row-end">
            <label for="ativo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ativo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarEstabelecimentoCli } from '@/models/estabelecimentoCli';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo=ref(false);
const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarEstabelecimentoCli());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('estabelecimento_cli', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idestabelecimento   = globalStore.idestabelecimento;
            objEdicao.value.idlogin             = globalStore.idlogin;
        }
        ckAtivo.value                   = objEdicao.value.ativo === 'S';
        objEdicao.value.idusuario       = globalStore.idusuario;
    } catch (error) {msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    try {
        isLoading.value         = true;
        objEdicao.value.ativo   = ckAtivo.value ? 'S' : 'N';
        const response          = await Api.genericPut('/cad/estabelecimento_cli', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error) {msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}

function validarDados(){
    let r = Validar.texto(objEdicao.value.nmcliente, 'Informe nome do cliente');
    if (!r.ok) return r.msg;
    r = Validar.texto(objEdicao.value.nmmunicipio, 'Informe nome do município');
    if (!r.ok) return r.msg;
    r = Validar.cNPJouCPF(objEdicao.value.cpfcnpj);
    if (!r.ok) return r.msg;
    return null;
}

onMounted(lerDados);
</script>